"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetIntegrationWarningSettings = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _useGetTeamSettingById = require("../../Shared/Teams/hooks/useGetTeamSettingById");

var _useGetIntegrationsByUserId = require("../../Shared/Users/hooks/useGetIntegrationsByUserId");

var _giftingFlow = require("../store/giftingFlow.selectors");

var _integrations = require("../../Shared/Users/store/integrations/integrations.types");

var _settings = require("../../Shared/Teams/store/settings/settings.types");

var useGetIntegrationWarningSettings = function useGetIntegrationWarningSettings(_ref) {
  var teamId = _ref.teamId,
      sendAsId = _ref.sendAsId;

  var _useGetTeamSettingsBy = (0, _useGetTeamSettingById.useGetTeamSettingsById)(teamId),
      settings = _useGetTeamSettingsBy.settings;

  var _useGetIntegrationsBy = (0, _useGetIntegrationsByUserId.useGetIntegrationsByUserId)(sendAsId),
      integrations = _useGetIntegrationsBy.integrations;

  var isIntegrationDataPending = (0, _reactRedux.useSelector)(_giftingFlow.getIsIntegrationDataPending);
  var isIntegrationDataFulfilled = (0, _reactRedux.useSelector)(_giftingFlow.getIsIntegrationDataFulfilled);
  var isDefault = (integrations === null || integrations === void 0 ? void 0 : integrations.email.provider) === _integrations.IntegrationProvider.Default;
  var isIntegrationRequired = (settings === null || settings === void 0 ? void 0 : settings.requireEmailIntegration) === _settings.RequireEmailIntegrationOption.Required;
  var isIntegrationNeverPrompt = (settings === null || settings === void 0 ? void 0 : settings.requireEmailIntegration) === _settings.RequireEmailIntegrationOption.NotShow;
  var isIntegrationBroken = (integrations === null || integrations === void 0 ? void 0 : integrations.email.brokenIntegrationProvider) !== null;
  var isNotConnected = isIntegrationDataFulfilled && !isIntegrationBroken && isDefault;
  var isBroken = isIntegrationDataFulfilled && isIntegrationBroken;
  var hasWarning = isIntegrationDataFulfilled && !isIntegrationNeverPrompt && (isNotConnected || isBroken);
  var isSendingBlocked = isIntegrationDataPending || hasWarning && isIntegrationRequired;
  return (0, _react.useMemo)(function () {
    return {
      hasWarning,
      isSendingBlocked,
      isIntegrationRequired,
      isIntegrationBroken
    };
  }, [isSendingBlocked, hasWarning, isIntegrationRequired, isIntegrationBroken]);
};

exports.useGetIntegrationWarningSettings = useGetIntegrationWarningSettings;